import { createSelector } from '@ngrx/store';
import {
	IRequestState,
	RequestEntitySelector,
} from '@app/pages/cmms/components/request/state/requests.reducer';
import { AuUtilsFunctions } from '@app/shared';

import {
	defaultPageSize,
	paginationQueryVariables,
} from '@app/pages/cmms/configs/pagination-query-variables';

export const selectRequestState = state => state.cmms.requestState;

export const requestAuPagination = createSelector(
	selectRequestState,
	(state: IRequestState) => {
		return state.requestAuPagination;
	}
);
export const requestPageSize = createSelector(
	selectRequestState,
	(state: IRequestState) =>
		state.requestAuPagination?.first ?? state.requestAuPagination?.last ?? defaultPageSize
);

export const requestsQueryVariables = createSelector(
	selectRequestState,
	(state: IRequestState) => state.requestsQueryVariables
);

export const requestsQueryVariablesWithoutPagination = createSelector(
	selectRequestState,
	(state: IRequestState) => {
		if (state.requestsQueryVariables) {
			return AuUtilsFunctions.excludeObjectKeys(
				state.requestsQueryVariables,
				paginationQueryVariables
			);
		}
	}
);

export const requestsTableColumnKeys = createSelector(
	selectRequestState,
	(state: IRequestState) => {
		return (state.tableColumnsConfig ?? []).map(column => column.key);
	}
);

export const requestsTableExportUrlQuery = createSelector(
	selectRequestState,
	(state: IRequestState) => state.exportUrlQuery
);

export const requestsIsExportable = createSelector(
	selectRequestState,
	(state: IRequestState) => state.isExportable
);

export const requestsExportTableData = createSelector({
	isExportable: requestsIsExportable,
	queryVariables: requestsQueryVariablesWithoutPagination,
	columnKeys: requestsTableColumnKeys,
	exportUrlQuery: requestsTableExportUrlQuery,
});

export const isLoadingRequests = createSelector(
	selectRequestState,
	(state: IRequestState) => state.isLoadingRequests
);

export const requestEntities = createSelector(
	selectRequestState,
	RequestEntitySelector.selectEntities
);

export const allRequests = createSelector(selectRequestState, (state: IRequestState) => {
	return {
		requests: RequestEntitySelector.selectAll(state),
		requestPagination: state.requestPagination,
	};
});

export const totalRequests = createSelector(
	selectRequestState,
	RequestEntitySelector.selectTotal
);

export const editingRequest = createSelector(
	selectRequestState,
	(state: IRequestState) => {
		return state.requestEdit;
	}
);

export const requestForEditing = createSelector(
	selectRequestState,
	(state: IRequestState) => state.requestEdit
);

export const requestData = createSelector(
	selectRequestState,
	(state: IRequestState) => state.requestData
);
